// Phone numbers are stored the way the back end expects them: an optional leading "+"
// followed by digits only, at most 15 of them (the E.164 limit). There is no grouping
// mask on purpose — digit groups differ from country to country.
const MAX_DIGITS = 15;

export const PHONE_PATTERN = /^\+?[0-9]{7,15}$/;

export const normalizePhone = (value) => {
  if (typeof value !== "string") return value;

  // A "+" only counts before the first digit, the way it is written in a number.
  const hasPlus = /^[^0-9]*\+/.test(value);
  const digits = value.replace(/\D/g, "").slice(0, MAX_DIGITS);
  return hasPlus ? `+${digits}` : digits;
};

// FormKit plugin: every value typed or pasted into the input goes through normalizePhone
// before it is stored, so spaces, brackets and dashes simply never make it in.
export const phoneMask = (node) => {
  node.hook.input((value, next) => next(normalizePhone(value)));
};
